export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.hook('vuetify:before-create', ({ vuetifyOptions }) => {
    vuetifyOptions.defaults ??= {}
    vuetifyOptions.defaults['CardDefault'] = {
      variant: 'outlined',
      class: 'rounded-2',
      color: '#4D5158',
      VCardItem: {
        class: 'p-6',
        VAvatar: {
          size: 'auto',
        },
        VIcon: {
          color: '#4D5158',
        },
        VCardTitle: {
          class: 'font-bold text-18',
        },
      },
      VCardText: {
        class: 'px-6 pb-6',
      },
    }

    vuetifyOptions.theme ??= {}
    vuetifyOptions.theme.themes ??= {}
    vuetifyOptions.theme.themes.light ??= {}
    vuetifyOptions.theme.themes.light.colors ??= {}
    vuetifyOptions.theme.themes.light.colors['on-white'] = '#1e1e1e'
  })
})
